import { Clapperboard, Play } from "lucide-react";
import { useTrailerModal } from "../context/TrailerModalContext";

export const PlayTrailerButton = ({ item, className = "" }) => {
  const { openTrailer } = useTrailerModal();
  return (
    <button
      type="button"
      onClick={() => openTrailer(item)}
      data-testid="play-trailer-btn"
      aria-haspopup="dialog"
      className={`btn-ghost inline-flex items-center gap-2 rounded-full px-7 py-3 text-sm font-medium uppercase tracking-[0.14em] ${className}`}
    >
      <Clapperboard className="h-4 w-4" /> Play Trailer
    </button>
  );
};

export const CardTrailerButton = ({ item }) => {
  const { openTrailer } = useTrailerModal();
  return (
    <button
      type="button"
      onClick={() => openTrailer(item)}
      data-testid="card-trailer-btn"
      data-item-id={item.id}
      aria-label={`Play trailer for ${item.title}`}
      className="absolute right-2 top-2 grid h-9 w-9 place-items-center rounded-full border border-[#D4AF37]/70 bg-black/70 text-[#D4AF37] backdrop-blur-md transition-[opacity,transform,background-color] duration-300 hover:scale-110 hover:bg-[#D4AF37] hover:text-black md:pointer-events-none md:opacity-0 md:group-hover:pointer-events-auto md:group-hover:opacity-100 md:focus-visible:pointer-events-auto md:focus-visible:opacity-100"
    >
      <Play className="ml-0.5 h-4 w-4 fill-current" />
    </button>
  );
};
